(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4491,646],{

/***/ 88640:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vps",
      function () {
        return __webpack_require__(46935);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41120);
/* harmony import */ var _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(538);
/* harmony import */ var _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57180);








var styles = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z), {
    main: {
        background: "#f1f5f8",
        position: "relative",
        zIndex: "3",
        paddingTop: "30px"
    }
});
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles);
function Loading(props) {
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classes.section,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
            className: classes.title,
            children: "Carregando...."
        })
    });
}


/***/ }),

/***/ 70646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Message; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41120);
/* harmony import */ var _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(538);
/* harmony import */ var _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57180);







var styles = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z), {
    main: {
        background: "#f1f5f8",
        position: "relative",
        zIndex: "3",
        paddingTop: "0px"
    }
});
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(styles);
function Message(props) {
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classes.section,
        style: {
            padding: "0"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
            className: classes.title,
            style: {
                marginTop: "20px"
            },
            children: props.children
        })
    });
}


/***/ }),

/***/ 46935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ VPS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61535);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41120);
/* harmony import */ var components_Functions_Loading__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24552);
/* harmony import */ var components_Functions_Message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70646);
/* harmony import */ var _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(538);
/* harmony import */ var pages_sections_HeaderSection_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75994);
/* harmony import */ var lang_lang_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34426);












var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1800), __webpack_require__.e(4817), __webpack_require__.e(5121), __webpack_require__.e(8853), __webpack_require__.e(7298), __webpack_require__.e(7814)]).then(__webpack_require__.bind(__webpack_require__, 37298));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37298)
            ];
        }
    }
});

var styles = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z), {
    main: {
        background: "#f1f5f8",
        position: "relative",
        zIndex: "3",
        paddingTop: "30px"
    }
});
// Sections for this page

var GridContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return __webpack_require__.e(/* import() */ 4041).then(__webpack_require__.bind(__webpack_require__, 64041));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64041)
            ];
        }
    },
    loading: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Functions_Loading__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
});
var GridItem = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return __webpack_require__.e(/* import() */ 6680).then(__webpack_require__.bind(__webpack_require__, 96680));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96680)
            ];
        }
    }
});
var ProductSection = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4817), __webpack_require__.e(628), __webpack_require__.e(8117)]).then(__webpack_require__.bind(__webpack_require__, 28117));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28117)
            ];
        }
    },
    ssr: true,
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Functions_Loading__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {});
    }
});
var Button = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1800), __webpack_require__.e(6719)]).then(__webpack_require__.bind(__webpack_require__, 16719));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16719)
            ];
        }
    }
});
var SEO = {
    title: "BB Host - VPS",
    description: "Servidores de alta disponibilidade em hardware dedicado e alta capacidade de escalonamento.",
    url: "https://www.bbhost.com.br/vps",
    type: "website",
    languageAlternates: [
        {
            hrefLang: "en",
            href: "https://www.bbhost.com.br/en/vps"
        },
        {
            hrefLang: "es",
            href: "https://www.bbhost.com.br/es/vps"
        }
    ]
};

var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(styles);
var fetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    });
};
function VPS(props) {
    var classes = useStyles();
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)(), locale = ref.locale, defaultLocale = ref.defaultLocale;
    var BareMetalRoute = locale === defaultLocale ? "/baremetal" : "/".concat(locale, "/baremetal");
    var ColocationRoute = locale === defaultLocale ? "/colocation" : "/".concat(locale, "/colocation");
    var ref1 = (0,swr__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)("https://api-frontend-site.bbhost.com.br/products-vps", fetcher), dataVPS = ref1.data;
    var products_tab = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Functions_Loading__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {});
    if (dataVPS !== undefined) {
        products_tab = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductSection, {
            name: "vps",
            products: dataVPS.products,
            locale: {
                locale: locale,
                defaultLocale: defaultLocale
            }
        });
    }
    if (dataVPS !== undefined && dataVPS.outStockAll) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_sections_HeaderSection_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    name: "vps",
                    seo: SEO
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(classes.main, classes.mainRaised),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classes.container,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(GridContainer, {
                                justifyContent: "center",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(GridItem, {
                                        xs: 12,
                                        sm: 12,
                                        md: 8,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Functions_Message__WEBPACK_IMPORTED_MODULE_7__["default"], {
                                                children: (0,lang_lang_js__WEBPACK_IMPORTED_MODULE_12__/* .trans */ .d)("products::outStockAll.title")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Functions_Message__WEBPACK_IMPORTED_MODULE_7__["default"], {
                                                children: (0,lang_lang_js__WEBPACK_IMPORTED_MODULE_12__/* .trans */ .d)("products::outStockAll.subTitle")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridItem, {
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(GridContainer, {
                                            justifyContent: "center",
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridItem, {
                                                    xs: 12,
                                                    sm: 12,
                                                    md: 4,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                        href: BareMetalRoute,
                                                        as: BareMetalRoute,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
                                                            color: "info",
                                                            block: true,
                                                            children: "BareMetal"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridItem, {
                                                    xs: 12,
                                                    sm: 12,
                                                    md: 4,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                        href: ColocationRoute,
                                                        as: ColocationRoute,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
                                                            color: "info",
                                                            block: true,
                                                            children: "Colocation"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridContainer, {
                                justifyContent: "center",
                                alignItems: "center",
                                style: {
                                    paddingTop: "20px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GridItem, {
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    children: products_tab
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_sections_HeaderSection_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                name: "vps",
                seo: SEO
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(classes.main, classes.mainRaised),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes.container,
                    children: products_tab
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
        ]
    });
}


/***/ }),

/***/ 57180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21086);
/* harmony import */ var _styles_jss_bbhost_imagesStyles_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89395);




var teamStyle = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    section: {
        padding: "20px 0",
        textAlign: "center"
    },
    title: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .title */ .TN), {
        marginBottom: "1rem",
        marginTop: "30px",
        minHeight: "32px",
        textDecoration: "none"
    })
}, _styles_jss_bbhost_imagesStyles_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    itemGrid: {
        marginLeft: "auto",
        marginRight: "auto"
    },
    cardTitle: _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .cardTitle */ .X5,
    smallTitle: {
        color: "#6c757d"
    },
    description: {
        color: "#999"
    },
    justifyCenter: {
        justifyContent: "center !important"
    },
    socials: {
        marginTop: "0",
        width: "100%",
        transform: "none",
        left: "0",
        top: "0",
        height: "100%",
        lineHeight: "41px",
        fontSize: "20px",
        color: "#999"
    },
    margin5: {
        margin: "5px"
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (teamStyle);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4888,1535,8653,9774,2888,179], function() { return __webpack_exec__(88640); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);